import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ApiActions from 'go/actions/api';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {EmailInputForm} from 'app-ui-componentlibrary';
import AccountWrapper from 'go/pages/account/AccountWrapper';
import {Alert} from 'componentLibrary';
import {API_AUTH_REGISTER_SUCCESS} from 'common/types';
import {Link} from 'react-router-dom';
import _ from 'lodash';

// we already have front-end validations for femaEmailAddress, but just in case...
const backendErrorMapping = {
  userExists:
    'An account already exists for this email. If you cannot access your account, please ',
  femaEmailAddress:
    'FEMA users are required to use their PIV card for authentication. Instead of registering, please sign in with your PIV credentials.',
};

// page to apply for an account to be created with the following username
export class CreateNewAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      formHasErrors: false,
      email: emptyStr,
      confirmEmail: emptyStr,
      backendErrorMsg: false,
      recaptchaToken: emptyStr,
      recaptchaRef: {},
    };
  }

  componentDidMount() {
    const loginGovIntegrationPWDRemoval = _.includes(
      this.props.toggles,
      'passwordRemovalLoginGovIntegration'
    );

    if (loginGovIntegrationPWDRemoval) {
      this.navigateToLogin();
    }
  }

  setEmail = (email) =>
    this.setState({email, backendErrorMsg: false, formHasErrors: false});
  setFormHasErrors = () => this.setState({formHasErrors: true});
  openModal = () => this.setState({modalOpen: true});

  closeModal = () => this.setState({modalOpen: false});

  handleRecaptchaChange = (recaptchaRef, response) =>
    this.setState({
      recaptchaToken: response,
      recaptchaRef: recaptchaRef,
    });

  navigateToLogin = () => {
    this.closeModal();
    this.props.navigateToLogin();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({backendErrorMsg: false});
    let {email, recaptchaToken} = this.state;
    const response = this.props.onSubmit(email.toLowerCase(), recaptchaToken);
    response.then((res) => {
      this.handleResponseFromServer(res);
    });
  };

  setBackendErrorMsg = (error) => {
    const defaultError =
      'There has been an unexpected error. If you continue to receive this message please contact FEMA for support.';
    const errorToShow = backendErrorMapping[error] || defaultError;
    this.setState({
      backendErrorMsg: errorToShow,
      resetPassError: error === 'userExists',
    });
  };

  handleResponseFromServer = (res) => {
    if (res !== undefined && res.type === API_AUTH_REGISTER_SUCCESS) {
      this.openModal();
    } else {
      // Reset CAPTCHA, since response can only be validated once
      if (this.state.recaptchaRef) {
        this.state.recaptchaRef.reset();
      }
      const errorCode = _.replace(_.get(res, 'payload.statusText'), /:.*$/, '');
      this.setBackendErrorMsg(errorCode);
    }
  };

  render() {
    const {
      backendErrorMsg,
      recaptchaToken,
      formHasErrors,
      email,
      modalOpen,
      resetPassError,
    } = this.state;
    const resetPassLink = '/requestPasswordReset';
    return (
      <React.Fragment>
        <FemaGoModal
          size="tiny"
          title="Success!"
          open={modalOpen}
          confirmAction={this.navigateToLogin}
          cancelAction={this.navigateToLogin}
        >
          <p>A verification link has been sent to your Email account.</p>
          <p>
            Please click that link and follow the next steps to verify your Email and
            continue the registration process.
          </p>
          <p>
            {' '}
            If you have not received the Email within 5-10 minutes, please check your spam
            or junk folder.
          </p>
        </FemaGoModal>

        <AccountWrapper
          title="Register a New Account"
          handleRecaptchaChange={this.handleRecaptchaChange}
          confirmAction={this.handleSubmit}
          cancelAction={this.navigateToLogin}
          disabled={formHasErrors || recaptchaToken === emptyStr}
          buttonText="Submit"
        >
          {backendErrorMsg && (
            <Alert
              header="Error "
              content={backendErrorMsg}
              type="error"
              dismissable={false}
            >
              {resetPassError && <Link to={resetPassLink}>reset your password.</Link>}
            </Alert>
          )}
          <EmailInputForm
            setEmail={this.setEmail}
            setFormHasErrors={this.setFormHasErrors}
          />
          <EmailInputForm
            label="Confirm Email"
            setEmail={this.setEmail}
            setFormHasErrors={this.setFormHasErrors}
            confirmEmailValidation={email}
          />
        </AccountWrapper>
      </React.Fragment>
    );
  }
}

const emptyStr = '';

export const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (email, recaptchaToken) => {
      const action = ApiActions.auth.register(email.toLowerCase(), recaptchaToken);
      const response = dispatch(action);
      return response;
    },
    navigateToLogin: () => {
      dispatch(push('/login'));
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewAccount);
